export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15024.21f449b0.jpg";